import React, { PropTypes } from 'react';
import cx from 'classnames';
import Modal from 'modules/common/components/Modal';
import Field from './Field';
import Big from 'big.js';
import $ from 'jquery';
import fetch from 'utils/fetch';
import CheckField from './CheckField';
import RichText from 'modules/common/components/RichText';

const constraintDecimals = (value, decimals) => {
  if (value) {
    return Big(value).toFixed(decimals);
  } else {
    return value;
  }
};

const computeLineTotalTTC = state => {
  const ht = constraintDecimals(state.total_ht.value, 2);
  const tvaRate = state.tva_rate.value;

  if (ht && tvaRate) {
    const ttc = Big(ht).times(
      Big(tvaRate)
        .div(100)
        .plus(1)
    );
    const tvaAmount = Big(ht).times(Big(tvaRate).div(100));
    state.tva_amount.value = tvaAmount.toFixed(2);
    state.tva_amount.error = false;
    state.total_ttc.value = ttc.toFixed(2);
    state.total_ttc.error = false;
  }

  return state;
};

const computeLineTotalHT = state => {
  const quantity = constraintDecimals(state.quantity.value, 2);
  const puHT = constraintDecimals(state.unit_price_ht.value, 4);

  if (quantity && puHT) {
    const ht = Big(puHT).times(Big(quantity));
    state.total_ht.value = ht.toFixed(2);
    state.total_ht.error = false;
  }

  return computeLineTotalTTC(state);
};

export default class AASTBillDetailModal extends React.Component {
  static propTypes = {
    line: PropTypes.object.isRequired,
    newLine: PropTypes.bool.isRequired,
    visible: PropTypes.bool.isRequired,
    readOnly: PropTypes.bool,
    onClose: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired,
    tvaOptions: PropTypes.array.isRequired,
    lineTypeOptions: PropTypes.array.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = this.parseLine(props);

    this.initDropdown = this.initDropdown.bind(this);
    this.setFromModel = this.setFromModel.bind(this);
  }

  componentDidMount() {
    $('#lineModelDropdown').dropdown({
      onChange: (value, label, $item) => {
        fetch(`/pco-manager/settings/lines.json/${value}`)
          .then(res => res.json())
          .then(res => {
            this.setFromModel(res);
          });
      },
    });
    fetch('/pco-manager/settings/lines.json')
      .then(res => res.json())
      .then(res => {
        this.setState({ lineModels: res });
      });
  }

  parseLine(props) {
    const wrap = value => {
      return {
        value: value,
        error: props.newLine,
      };
    };

    const form = {};
    Object.keys(props.line).forEach(k => {
      form[k] = wrap(props.line[k]);
    });

    // line_type, tva_rate and order can't be wrong
    form.line_type.error = false;
    form.order.error = false;
    form.tva_rate.error = false;
    if (form.accounting_code) {
      form.accounting_code.error = false;
    }
    if (form.by_default) {
      form.by_default.error = false;
    }

    if (props.newLine == true) {
      form.id = {
        value: 0,
        error: false,
      };
    }

    return form;
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.line !== this.props.line) {
      const { lineModels } = this.state;
      this.setState({
        ...this.parseLine(nextProps),
        lineModels,
      });
    }
  }

  onChange = (evt, error) => {
    $('#lineModelDropdown').dropdown('restore defaults');

    this.setState({
      [evt.target.name]: {
        value: evt.target.value,
        error,
      },
    });
  };

  onChangeDescription = value =>
    this.setState({
      description: {
        value,
        error: false,
      },
    });

  onChangeAccountingCode = value =>
    this.setState({
      accounting_code: {
        value: value.target.value,
        error: false,
      },
    });

  save = evt => {
    const newState = {};
    Object.keys(this.state).forEach(k => {
      if (this.state[k].value === 0) {
        newState[k] = 0;
      } else if (k === 'description' || k === 'accounting_code') {
        newState[k] = this.state[k].value;
      } else {
        newState[k] = this.state[k].value || this.state[k];
      }
    });

    this.props.onSave(newState);
  };

  onBlur = (evt, error) => {
    const newProp = {};
    newProp[evt.target.name] = {
      value: evt.target.value,
      error,
    };
    const newState = Object.assign({}, this.state, newProp);

    switch (evt.target.name) {
      case 'unit_price_ht':
      case 'quantity':
        computeLineTotalHT(newState);
        break;
      case 'total_ttc':
      case 'tva_rate':
        computeLineTotalTTC(newState);
        break;
      default:
        break;
    }

    this.setState(newState);
  };

  setFromModel(model) {
    let newState = this.state;
    Object.keys(model).forEach(k => {
      if (this.state[k]) {
        newState[k] = {
          value: model[k],
          error: false,
        };
      }
    });
    this.setState(newState);
  }

  initDropdown() {
    $('#lineModelDropdown').dropdown({
      onChange: (value, label, $item) => {
        if (value) {
          fetch(`/pco-manager/settings/lines.json/${value}`)
            .then(res => res.json())
            .then(res => {
              this.setFromModel(res);
            });
        }
      },
    });
  }

  render() {
    const {
      visible,
      readOnly,
      line,
      isModel,
      onClose,
      tvaOptions,
      lineTypeOptions,
    } = this.props;
    const data = this.state;
    const { lineModels } = this.state;

    const hasError =
      Object.keys(data).filter(
        k =>
          k !== 'description' &&
          k !== 'accounting_code' &&
          data[k] &&
          data[k].error
      ).length > 0;

    const buttonClass = cx('ui approve primary button icon labeled', {
      disabled: readOnly || hasError,
    });

    const title = line ? 'Modification' : 'Création';

    const dropdownClass = cx('ui dropdown field', {
      disabled: readOnly,
    });

    const modelDropdownClass = cx('ui selection search dropdown', {
      disabled: !lineModels || !lineModels.length,
    });

    const lineModelDropdownStyle = { marginLeft: '20px' };

    const accounting_code =
      data.accounting_code && data.accounting_code.value
        ? data.accounting_code.value
        : '';

    return (
      <Modal
        isOpened={visible}
        onOpen={this.initDropdown}
        onClose={onClose}
        closable
      >
        <div className="header" style={{ position: 'relative', zIndex: 1 }}>
          <div className="ui grid" style={{ overflow: 'initial' }}>
            <div className="row">
              <div className="two wide column middle aligned">{title}</div>
              <div className="ten wide column">
                <div
                  id="lineModelDropdown"
                  className={modelDropdownClass}
                  style={lineModelDropdownStyle}
                >
                  <input type="hidden" name="lineModel" />
                  <i className="dropdown icon" />
                  <div className="default text">
                    Selection de modèles de lignes
                  </div>
                  <div className="menu">
                    {lineModels &&
                      lineModels.length &&
                      lineModels.map(model => (
                        <div
                          key={model.id}
                          className="item"
                          data-value={model.id}
                        >
                          {model.label}
                        </div>
                      ))}
                  </div>
                </div>
              </div>
              <div className="four wide column middle aligned">
                {isModel && (
                  <CheckField
                    label="Insertion par défaut"
                    name="by_default"
                    value={data.by_default}
                    onChange={this.onChange}
                    onBlur={this.onBlur}
                    required={true}
                    readOnly={readOnly}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="content ui form">
          <form>
            <div className="two fields">
              <Field
                label="Libellé"
                name="label"
                value={data.label}
                onChange={this.onChange}
                onBlur={this.onBlur}
                required={true}
                readOnly={readOnly}
              />
              <div className="field required">
                <label>Type</label>
                <select
                  id="line_type"
                  name="line_type"
                  className={dropdownClass}
                  value={data.line_type.value}
                  onChange={this.onChange}
                  onBlur={this.onBlur}
                >
                  {lineTypeOptions &&
                    lineTypeOptions.map((opt, index) => (
                      <option key={index} value={opt.value}>
                        {opt.text}
                      </option>
                    ))}
                </select>
              </div>
            </div>
            <div className="two fields">
              <Field
                label="Prix unitaire HT"
                name="unit_price_ht"
                value={data.unit_price_ht}
                onChange={this.onChange}
                onBlur={this.onBlur}
                required={true}
                number={true}
                digits={4}
                readOnly={readOnly}
              />
              <Field
                label="Quantité"
                name="quantity"
                value={data.quantity}
                onChange={this.onChange}
                onBlur={this.onBlur}
                required={true}
                number={true}
                digits={2}
                readOnly={readOnly}
              />
            </div>
            <div className="two fields">
              <div className="field">
                <label>Taux de TVA</label>
                <select
                  id="tva_rate"
                  name="tva_rate"
                  className={dropdownClass}
                  value={data.tva_rate.value}
                  onChange={this.onChange}
                  onBlur={this.onBlur}
                >
                  {tvaOptions &&
                    tvaOptions.map((opt, index) => (
                      <option key={index} value={opt.value}>
                        {opt.value}%
                      </option>
                    ))}
                </select>
              </div>
              <Field
                label="Montant TVA"
                name="tva_amount"
                value={data.tva_amount}
                onChange={this.onChange}
                onBlur={this.onBlur}
                required={true}
                number={true}
                digits={2}
                readOnly={readOnly}
              />
            </div>
            <div className="two fields">
              <Field
                label="Total HT"
                name="total_ht"
                value={data.total_ht}
                onChange={this.onChange}
                onBlur={this.onBlur}
                required={true}
                number={true}
                digits={2}
                readOnly={readOnly}
              />
              <Field
                label="Total TTC"
                name="total_ttc"
                value={data.total_ttc}
                onChange={this.onChange}
                onBlur={this.onBlur}
                required={true}
                number={true}
                digits={2}
                readOnly={readOnly}
              />
            </div>
            <div className="two fields">
              <div className="ui field">
                <label>Code comptable</label>
                <input
                  type="text"
                  id="accounting_code"
                  name="accounting_code"
                  value={accounting_code}
                  onChange={this.onChangeAccountingCode}
                />
              </div>
            </div>
            <div className="ui field">
              <label>Descriptif</label>
              <RichText
                value={data.description.value || ''}
                onChange={this.onChangeDescription}
              />
              <input
                type="hidden"
                name="description"
                value={data.description.value || ''}
              />
            </div>
          </form>
        </div>
        <div className="actions">
          <button className={buttonClass} onClick={this.save}>
            <i className="icon add" />
            Editer
          </button>
        </div>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/saas/common/bill/AASTBillDetailModal.js